export default __webpack_public_path__ + "static/media/033-guinea pig.7d988faf.svg";